import api from '..';

export const symbolConfigRequest = () => {
  return api.get('/trading-calculators/symbol');
};

const getParams = (payload) => {
  const params = { ...payload };
  if (typeof params.symbol === 'object') {
    params.symbol = params.symbol.value;
  }
  return params;
};

export const allInOneCalculatorRequest = (payload) => {
  return api.get('/trading-calculators/all-in-one', { params: getParams(payload) });
};

export const currencyCalculatorRequest = (payload) => {
  return api.get('/trading-calculators/currency', { params: getParams(payload) });
};

export const pipValueCalculatorRequest = (payload) => {
  return api.get('/trading-calculators/pip-value', { params: getParams(payload) });
};

export const marginCalculatorRequest = (payload) => {
  return api.get('/trading-calculators/margin', { params: getParams(payload) });
};

export const swapsCalculatorRequest = (payload) => {
  return api.get('/trading-calculators/swaps', { params: getParams(payload) });
};

export const profitLossCalculatorRequest = (payload) => {
  return api.get('/trading-calculators/profit-loss', { params: getParams(payload) });
};

export const getCurrencySpecsRequest = () => {
  return api.get('/trading-calculators/currency-specs');
};
